import { render, staticRenderFns } from "./_FixedHtmlTemplateForm.vue?vue&type=template&id=2550473e&scoped=true&"
import script from "./_FixedHtmlTemplateForm.vue?vue&type=script&lang=ts&"
export * from "./_FixedHtmlTemplateForm.vue?vue&type=script&lang=ts&"
import style0 from "./_FixedHtmlTemplateForm.vue?vue&type=style&index=0&id=2550473e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2550473e",
  null
  
)

export default component.exports